(function () {
  function money(cents) {
    var frac = cents % 100 ? 2 : 0;
    return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: frac, maximumFractionDigits: frac });
  }
  function parseTiers(s) {
    return (s || '').split(',').map(function (p) { var a = p.split(':'); return { max: +a[0], cents: Math.round(+a[1] * 100) }; }).filter(function (t) { return t.max > 0; });
  }
  function init(root) {
    if (root.dataset.init) return;
    root.dataset.init = '1';
    var d = root.dataset;
    var sqft = +d.sqft || 200;
    var tiers = parseTiers(d.tiers);
    var freeAt = tiers.length ? tiers[tiers.length - 1].max + 1 : 1;
    var live = d.live === 'true';
    var colors = root.querySelectorAll('[data-color]');
    var qtys = root.querySelectorAll('[data-qty]');
    var moreBox = root.querySelector('[data-more-box]');
    var moreInput = root.querySelector('[data-more-input]');
    var tierEls = root.querySelectorAll('[data-tier]');
    var swatch = root.querySelector('[data-swatch]');
    var swatchImg = root.querySelector('[data-swatch-img]');
    var el = function (s) { return root.querySelector(s); };
    var txt = function (s, v) { var n = el(s); if (n) n.textContent = v; };
    var val = function (s, v) { var n = el(s); if (n) n.value = v; };
    var state = { color: colors[0] || null, qty: Math.max(+d.defaultRolls || 1, 1) };

    function freight(n) {
      for (var i = 0; i < tiers.length; i++) if (n <= tiers[i].max) return tiers[i].cents;
      return 0;
    }
    function tierIndex(n) {
      for (var i = 0; i < tiers.length; i++) if (n <= tiers[i].max) return i;
      return tiers.length;
    }

    function render() {
      var c = state.color;
      if (!c) return;
      var n = state.qty;
      var cents = +c.dataset.cents || 0;
      var sub = cents * n;
      var fr = freight(n);
      var name = c.dataset.name;
      var rolls = n + (n === 1 ? ' roll' : ' rolls');
      if (swatch) {
        swatch.style.setProperty('--base', c.dataset.base);
        swatch.style.setProperty('--fleck', c.dataset.fleck);
        swatch.style.setProperty('--fleck2', c.dataset.fleck2);
      }
      if (swatchImg && c.dataset.img && swatchImg.getAttribute('src') !== c.dataset.img) {
        swatchImg.removeAttribute('srcset');
        swatchImg.src = c.dataset.img;
        swatchImg.alt = name + ' rubber flooring, close up';
      }
      qtys.forEach(function (b) {
        var q = b.dataset.qty;
        var on = q === 'more' ? n >= freeAt : +q === n;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (moreBox) moreBox.hidden = n < freeAt;
      var ti = tierIndex(n);
      tierEls.forEach(function (t, i) { t.classList.toggle('is-on', i === ti); });
      txt('[data-swatch-tag]', name.toUpperCase());
      txt('[data-color-name]', name);
      txt('[data-qty-label]', rolls + ' · ' + (sqft * n).toLocaleString('en-US') + ' sq ft');
      txt('[data-total]', money(sub));
      txt('[data-summary]', name + ' · ' + rolls + ' × ' + money(cents) + ' · ' + (sqft * n).toLocaleString('en-US') + ' sq ft');
      txt('[data-line-sub]', money(sub));
      txt('[data-line-freight]', fr ? money(fr) + ' at checkout' : 'Free');
      txt('[data-ship-tag]', fr ? 'FLAT-RATE FREIGHT' : 'FREE FREIGHT');
      var nudge = el('[data-nudge]');
      if (nudge) {
        var need = freeAt - n;
        var show = need > 0 && need <= 3;
        nudge.hidden = !show;
        if (show) nudge.textContent = 'Add ' + need + ' more roll' + (need === 1 ? '' : 's') + ' and freight is free. Saves ' + money(fr) + '.';
        nudge.dataset.to = freeAt;
      }
      val('[data-vid-input]', c.dataset.vid || '');
      val('[data-qty-input]', n);
      var avail = c.dataset.avail === 'true';
      var buy = el('[data-buy]');
      var add = el('[data-add]');
      if (buy) { buy.textContent = avail ? 'Checkout' : 'Sold out'; buy.disabled = !avail; }
      if (add) add.disabled = !avail;
    }

    function setQty(n) {
      n = Math.max(1, Math.min(+n || 1, 99));
      state.qty = n;
      if (moreInput && n >= freeAt) moreInput.value = n;
      render();
    }
    colors.forEach(function (b) {
      b.addEventListener('click', function () {
        colors.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true');
        state.color = b;
        render();
      });
    });
    qtys.forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.dataset.qty === 'more') setQty(Math.max(freeAt, +(moreInput && moreInput.value) || freeAt));
        else setQty(b.dataset.qty);
      });
    });
    if (moreInput) moreInput.addEventListener('input', function () { var v = +moreInput.value; if (v >= freeAt) { state.qty = Math.min(v, 99); render(); } });
    if (moreInput) moreInput.addEventListener('change', function () { setQty(Math.max(freeAt, +moreInput.value || freeAt)); });
    root.querySelectorAll('[data-step]').forEach(function (b) {
      b.addEventListener('click', function () { setQty(Math.max(freeAt, state.qty + (+b.dataset.step))); });
    });
    var nudgeBtn = el('[data-nudge]');
    if (nudgeBtn) nudgeBtn.addEventListener('click', function () { setQty(+nudgeBtn.dataset.to); });
    var form = root.querySelector('[data-form]');
    if (form) form.addEventListener('submit', function (e) {
      var vid = el('[data-vid-input]');
      if (!live || !vid || !vid.value) e.preventDefault();
    });
    root.setQty = setQty;
    render();
  }
  function boot() { document.querySelectorAll('[data-f1080-flooring]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();